
// REL
// export const BASE_DOMAIN = `support-bot.rel.oa-stuff.com`;

// PROD
export const BASE_DOMAIN = `supportbot-co.top`;

export const BASE_URL = `https://${BASE_DOMAIN}/api`;